import { CareerEducationModel } from "./CareerEducationModel";
import { CareerMetaModel } from "./CareerMetaModel";
import { CareerTypeModel } from "./CareerTypeModel";

export class CareerItemModel {
    constructor(public id: number, public title: string, public slug: string, public description: string, public type: CareerTypeModel, public education_level: CareerEducationModel, public location: string, public image_url: string, public job_requirements: string[], public job_description: string[], public meta: CareerMetaModel,
        public share_url: string){}
}